import { AppModal } from 'shared/UI/UIKit/Modal';
import { EducationClassForm } from 'entities/education-class';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppEditIcon } from 'shared/UI/UIKit/icons/Edit';
import type { EducationClass } from 'shared/api';
import { useEditEducationClass } from '../model';
import styles from './styles.module.scss';

interface EditEducationClassProps {
  selectedEducationClass: EducationClass;
}

export const EditEducationClass = ({ selectedEducationClass }: EditEducationClassProps) => {
  const {
    state: { form, visible, isLoading },
    methods: { onSubmit, hideModal, showModal },
  } = useEditEducationClass(selectedEducationClass);

  const footer = (
    <AppFlex direction="row">
      <AppButton onClick={onSubmit}>Сохранить</AppButton>
      <AppButton type="outline" onClick={hideModal}>
        Отмена
      </AppButton>
    </AppFlex>
  );

  return (
    <>
      <AppEditIcon onClick={showModal} className={styles.icon} />

      <AppModal
        visible={visible}
        onCancel={hideModal}
        maskClosable={false}
        content={<EducationClassForm form={form} />}
        destroyOnClose
        footer={footer}
        loading={isLoading}
        title={'Редактировать класс'}
      />
    </>
  );
};
